//#region src/url_target.ts
var UrlTarget = /* @__PURE__ */ function(UrlTarget) {
	UrlTarget["ExternalBrowser"] = "external-browser";
	UrlTarget["InternalBrowser"] = "internal-browser";
	UrlTarget["ShareDialog"] = "share-dialog";
	return UrlTarget;
}(UrlTarget || {});
//#endregion
export { UrlTarget };

//# sourceMappingURL=url_target.js.map